import GIFLanding from './GIFLanding'

export default GIFLanding;